const route = {
	path: '/components',
	name: 'components',
	component: () => import('@/pages/page-components'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/components.js